import { useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toast, ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SSOCallback = () => {
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get("error");

    if (error) {
      toast.error(decodeURIComponent(error), {
        position: "top-right",
        transition: Zoom,
        autoClose: 4000,
      });
      setTimeout(() => history.push("/login"), 4000);
      return;
    }

    const access = params.get("access");
    const refresh = params.get("refresh");
    const role = params.get("role");
    const username = params.get("username");
    const email = params.get("email");

    if (!access) {
      toast.error("SSO login failed. Please try again.", {
        position: "top-right",
        transition: Zoom,
        autoClose: 3000,
      });
      setTimeout(() => history.push("/login"), 3000);
      return;
    }

    sessionStorage.setItem("userToken", access);
    sessionStorage.setItem("userRole", role);
    sessionStorage.setItem("email", email);

    toast.success(`Welcome ${username}! Redirecting...`, {
      position: "top-right",
      autoClose: 1500,
    });

    setTimeout(() => {
      if (role === "SystemAdmin" || role === "System Admin") {
        history.push("/system-admin");
      } else if (role === "Useradmin") {
        history.push("/admin/dashboard");
      } else {
        history.push("/OrgChart");
      }
    }, 1500);
  }, [history]);

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-900">
      <div className="text-white text-2xl font-semibold mb-4">
        Completing sign in...
      </div>
      <div className="w-10 h-10 border-4 border-white border-t-orange-400 rounded-full animate-spin" />
      <ToastContainer />
    </div>
  );
};

export default SSOCallback;
